import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-configura-producto-compartido',
  templateUrl: './configura-producto-compartido.component.html',
  styleUrls: ['./configura-producto-compartido.component.scss']
})
export class ConfiguraProductoCompartidoComponent {

  @Input() requiereContacto: boolean;
  @Input() requiereTecnico: boolean;
  @Input() edicion: boolean;
  @Input() configProdTransbank: FormGroup;
  @Input() configProdIndependiente: FormGroup;
  @Input() configProductos: FormGroup;
  @Input() mensajeErrorConfiguracionProducto: any;
  @Input() requiereNombreLinkPago: boolean;
  @Input() conLimite: boolean;
  @Input() yoRecibo: boolean;
  @Input() autocomplete:any;
  @Input() messageRutError:any;
  @Input() onOff:string;
  @Input() isPersonaNatural:boolean;

  @Output() yoReciboBtn = new EventEmitter<any>();
  @Output() otraPersonaBtn = new EventEmitter<any>();
  @Output() on = new EventEmitter<any>();
  @Output() off = new EventEmitter<any>();

  yoReciboToggle(){
    this.yoReciboBtn.emit();
  }
  otraPersonaToggle(){
    this.otraPersonaBtn.emit();
  }
  onParent(){
    this.on.emit();
  }
  offParent(){
    this.off.emit();
  }

}
